import React, { Component } from 'react';
import './PreviewLabel.css';

class PreviewLabel extends Component {
	render(){
		let c;

		if (this.props.company) {
			c = this.props.company
		}
		return(
			<div className="preview-label-content">
			<div className="ticker-label">
			<p>{c.ticker ? c.ticker : "N/A"}</p>
			</div>
			<p className="prev-company-name">{c.name ? c.name : "Company N/A"}</p>
			<div className="preview-label-right">
			<p>{c.state ? c.state : " "} {c.country ? c.country : " "}</p>
			<p>{c.cb_sector ? c.cb_sector : " "}</p>
			</div>
			</div>
			)
	}
}

export default PreviewLabel;


// WEBPACK FOOTER //
// ./src/components/CompanyResults/PreviewLabel/PreviewLabel.js